import styled from "styled-components";
import calendarioImagen from "../../assets/imagenes/calendarioTarjeta.png";
import alumnosImagen from "../../assets/imagenes/estudiantesTarjeta.png";
import billetesImagen from "../../assets/imagenes/dolaresTarjeta.png";
import sobreCampana from "../../assets/imagenes/sobreCampana.png";
import { textoOscuro } from "../UI/variables";

const StyledSection = styled.section`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  margin: 16px 0 16px 0;
`;
const StyledDiv = styled.div`
  background-color: white;
  width: 160px;
  height: 160px;
  border-radius: 15px;
  text-align: center;
  margin: 4px 8px 4px 8px;
`;
const StyledImg = styled.img`
  width: 72px;
  height: 72px;
  margin: 8px 8px 0px 8px;
`;
const StyledP = styled.p`
  color: ${textoOscuro};
  font-weight: 500;
  width: 144px;
  height: 64px;
  margin: 0px 8px 0px 8px;
  display: flex;
  align-items: center;
`;
const BeneficiosOwner = () => {
  return (
    <StyledSection>
      <StyledDiv>
        <StyledImg src={calendarioImagen} alt="Calendario" />
        <StyledP>Administra fechas de entrada y salida</StyledP>
      </StyledDiv>
      <StyledDiv>
        <StyledImg src={billetesImagen} alt="Billetes"/>
        <StyledP>Administra los pagos de inquilinos</StyledP>
      </StyledDiv>
      <StyledDiv>
        <StyledImg src={sobreCampana} alt="Explorando una casa"/>
        <StyledP>Recibe recordatorios de alquileres vencidos</StyledP>
      </StyledDiv>
      <StyledDiv>
        <StyledImg src={alumnosImagen} alt="Grupo de estudiantes buscando habitaciones"/>
        <StyledP>Publica tus habitaciones para  inquilinos</StyledP>
      </StyledDiv>
    </StyledSection>
  );
};
export default BeneficiosOwner;
